import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhTW from 'antd/locale/zh_TW';
import enUS from 'antd/locale/en_US';
import thTH from 'antd/locale/th_TH';
import viVN from 'antd/locale/vi_VN';

import './i18n';
import { useTranslation } from 'react-i18next';

import MainLayout from './components/Layout/MainLayout';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import PermissionRoute from './components/Auth/PermissionRoute';
import RecordPermissionRoute from './components/Auth/RecordPermissionRoute';
import ReadPermissionRoute from './components/Auth/ReadPermissionRoute';
import Home from './pages/Home';
import Login from './pages/Login';
import Users from './pages/Users';
import Reports from './pages/Reports';
import BarnMaintenance from './pages/BarnMaintenance';

import './index.css';
import './assets/jf-openhuninn-2.1.ttf';

const theme = {
  token: {
    colorPrimary: '#9a8a7a',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#f5222d',
    colorInfo: '#9a8a7a',
    borderRadius: 8,
    fontFamily: 'jf-open-huninn, "Noto Sans Thai", "Noto Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  components: {
    Button: {
      borderRadius: 8,
      controlHeight: 40,
    },
    Card: {
      borderRadiusLG: 12,
    },
    Menu: {
      itemBg: 'transparent',
      subMenuItemBg: 'transparent',
    },
  },
};

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const { i18n } = useTranslation();
  const [antdLocale, setAntdLocale] = useState(zhTW);

  useEffect(() => {
    const localeMap = {
      en: enUS,
      th: thTH,
      vi: viVN
    };
    const langKey = i18n.language?.split('-')[0];
    setAntdLocale(localeMap[langKey] || localeMap[i18n.language] || zhTW);
  }, [i18n.language]);

  return (
    <ConfigProvider locale={antdLocale} theme={theme}>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route
                        path="/barn/:barnId"
                        element={
                          <RecordPermissionRoute>
                            <BarnMaintenance />
                          </RecordPermissionRoute>
                        }
                      />
                      <Route
                        path="/reports/*"
                        element={
                          <ReadPermissionRoute>
                            <Reports />
                          </ReadPermissionRoute>
                        }
                      />
                      <Route
                        path="/users"
                        element={
                          <PermissionRoute>
                            <Users />
                          </PermissionRoute>
                        }
                      />
                    </Routes>
                  </MainLayout>
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
      </Router>
    </ConfigProvider>
  );
}

export default App;
